import Service from '../service';
import {
    toTree
} from '@/utils/'
import Vue from 'vue';
import _ from 'lodash';
import {
    Message
} from 'element-ui';
import router from '@/router'

const actions = {
    handleSetCollapse({
        commit
    }, isCollapse) {
        commit('setCollapse', isCollapse)
    },
    handleSetLanguage({
        commit,
        state,
        dispatch,
    }, lang) {
        Service.fetch({
            url: 'homepageChangeUserLang',
            params: {
                language: lang
            }
        }).then(res => {
            if (res.code == '1') {
                // 切换语言以后刷新页面调用接口
                commit('setLanguage', lang)
                console.log(state.currentModule)
                // 如果在首页
                if(!state.currentModule) {
                    dispatch('handleGetUserMenu', [])
                    dispatch('handleSetUserInfoAction').then(res => {
                        location.reload();
                    })
                    return void 0;
                }
                // 获取菜单，获取权限 用当前moduleCode获取权限
                Promise.all([dispatch('handleGetUserMenu', state.currentRole), Service.fetch({
                    url: 'sysAuthRoleGetHrExclusiveRoles',
                    params: {
                        menuCode: state.currentModule,
                    }
                }), dispatch('handleSetUserInfoAction')]).then((data) => {
                    const res2 = data[1];
                    if(res2.code == '1') {
                        const { data } = res2;
                        commit('handleSetRoles', data);
                        location.reload();
                    }
                })
            }
        })
    },
    // 获取用户信息 和 默认语言
    handleSetUserInfoAction({
        commit
    }) {
        // commit('handleSetUserInfo', userInfo)
        return new Promise((resolve, reject) => {
            // 设置网关Authorization
            const auth = Vue.$cookies.get('WEBSESSIONID');
            Promise.all([Service.fetch({
                url: 'commonInfo'
            }), Service.fetch({
                url: 'homepageGetUserLang'
            })]).then(responseList => {
                console.log(responseList);
                const userRes = responseList[0];
                const langRes = responseList[1];
                if (userRes.code == '1') {
                    const message = userRes.data;
                    commit('handleSetUserInfo', message)
                }
                if (langRes.code == '1') {
                    const lang = langRes.data;
                    commit('setLanguage', lang);
                }
                resolve('Y');
            })
        })
    },
    // 获取用户菜单
    handleGetUserMenu({
        commit
    }, role) {
        if(!Array.isArray(role)) {
            role = [];
        }
        return new Promise((resolve, reject) => {
            Service.fetch({
                url: 'sysUserLoadMyMenu',
                methods: 'post',
                forceExecute: true,
                headers: {
                    'Content-Type': 'application/json'
                },
                data: JSON.stringify(role)
            }).then(res => {
                if (res.code == '1') {
                    const {
                        data
                    } = res;
                    if (data && data.length) {
                        // 遍历成树
                        const menusData = _.sortBy(data, item => item.orderNum);
                        const menus = toTree(menusData, "menuId", "parentId", "children", false);
                        // data 对应非树形结构 用来遍历资源是否存在按钮权限
                        commit('handleSetMenus', {
                            menus,
                            data
                        })
                        resolve(menusData);
                    } else {
                        // Message.error("该角色下未查询到相关菜单");
                        commit('handleSetMenus', {
                            menus: [],
                            data: [],
                        })
                    }
                }
            })
        })
    },
    handleSetAsideOpen({ commit }, ids) {
        commit('SET_DEFAULTACTIVE', ids);
    },
    handleSetOATitleAction({
        commit
    }, title) {
        commit('handleSetOATitle', title);
    },
    // 切换用户权限
    handleSetRoles({
        commit,
        dispatch
    }, code) {
        if(!code) { return void 0;}
        return new Promise(resolve => {
            // 设置首页modules
            commit('handleSetCurrentModule', code)
            Service.fetch({
                url: 'sysAuthRoleGetHrExclusiveRoles',
                params: {
                    menuCode: code,
                }
            }).then(res => {
                if (res.code == '1') {
                    const {
                        data
                    } = res;

                    let currentRole = {};
                    if (data.length > 1 && code != 'index:teamAppraise') {
                        currentRole = data.find(role => role.isOption);
                    } else if(code == 'index:teamAppraise') {
                        currentRole = {
                            roleId: data.map(role => role.roleId).join(',')
                        };
                    } else {
                        currentRole = data.length && data[0];
                    }
                    if (currentRole) {
                        dispatch('handleSetCurrentRole', currentRole.roleId.split(','));

                    }
                    commit('handleSetRoles', data);
                    resolve(currentRole);
                }

            })
        })
    },
    handleToDoSetRoles({
        commit,
        dispatch
    }, code) {
        if(!code) { return void 0;}
        return new Promise(resolve => {
            // 设置首页modules
            commit('handleSetCurrentModule', code)
            Service.fetch({
                url: 'sysAuthRoleGetHrExclusiveRoles',
                params: {
                    menuCode: code,
                }
            }).then(res => {
                if (res.code == '1') {
                    const {
                        data
                    } = res;
                    let currentRole = {};
                    if (data.length > 1 && code != 'index:teamAppraise') {
                        currentRole = data.find(role => role.isOption);
                    } else if(code == 'index:teamAppraise') {
                        currentRole = {
                            roleId: data.map(role => role.roleId).join(',')
                        };
                    } else {
                        currentRole = data.length && data[0];
                    }
                    if (currentRole) {
                        dispatch('handleSetToDoCurrentRole', currentRole.roleId.split(','));

                    }
                    commit('handleSetRoles', data);
                    resolve(currentRole);
                }

            })
        })
    },
    //待办设置角色后不跳转
    handleSetToDoCurrentRole({
        commit,
        dispatch,
        state
    }, currRole) {
        if (!currRole) {
            commit('handleSetCurrentModule', '')
            commit('handleSetCurrentRole', '')
            dispatch('handleGetUserMenu', [])
        } else {
            let roleId = '';
            roleId = currRole.join(',')
            Service.fetch({
                url: 'sysAuthRoleMyRoleByMenuId',
                params: {
                    roleId: roleId
                }
            })
            commit('handleSetCurrentRole', currRole);
            dispatch('handleGetUserMenu', currRole).then(data => {
                let url = "",
                    target = null;
                const menus = _.sortBy(data, item => item.orderNum);
                switch (state.currentModule) {
                    case "index:HR":
                        target = menus.find(
                            (menu) =>
                            menu.type == "1" &&
                            (menu.code.includes("vinda:appraise") || menu.code.includes("vinda:sysCfg:") ||
                            menu.code.includes("vinda:role"))
                        );
                        if (target) {
                            url = target.url.trim();
                        }
                    case "index:myAppraise":
                        target = menus.find(
                            (menu) =>
                            menu.type == "1" && menu.code.includes("vinda:appraise:myAppraise")
                        );
                        if (target) {
                            url = target.url.trim();
                        }
                        break;
                    case "index:teamAppraise":
                        target = menus.find(
                            (menu) =>
                            menu.type == "1" && (menu.code.includes("vinda:appraise:teamAppraise") || menu.code.includes("vinda:rank"))
                        );
                        if (target) {
                            url = target.url.trim();
                        }
                        break;
                }
                // if (url != router.currentRoute.fullPath) {       //去掉跳转相关代码,仅仅提供下拉选择角色的框
                //     dispatch('handleSetAsideOpen', url)
                //     router.push({
                //         path: url,
                //     });
                //     setTimeout(() => {
                //         location.reload();
                //     }, 500);
                // }
            })
        }
    },
    // 设置当前角色
    handleSetCurrentRole({
        commit,
        dispatch,
        state
    }, currRole) {
        let flag=true      
        if(location.href.includes('rankDetail')){  //在评分界面切换
            flag=false
        }
        console.log('flag',flag);
        if (!currRole) {
            commit('handleSetCurrentModule', '')
            commit('handleSetCurrentRole', '')
            dispatch('handleGetUserMenu', [])
        } else {
            let roleId = '';
            roleId = currRole.join(',')
            Service.fetch({
                url: 'sysAuthRoleMyRoleByMenuId',
                params: {
                    roleId: roleId
                }
            })
            commit('handleSetCurrentRole', currRole);
            dispatch('handleGetUserMenu', currRole).then(data => {
                let url = "",
                    target = null;
                const menus = _.sortBy(data, item => item.orderNum);
                switch (state.currentModule) {
                    case "index:HR":
                        console.log(menus)
                        target = menus.find(
                            (menu) =>
                            menu.type == "1" &&
                            (menu.code.includes("vinda:appraise") || menu.code.includes("vinda:sysCfg:") ||
                            menu.code.includes("vinda:role"))
                        );
                        if (target) {
                            url = target.url.trim();
                        }
                    case "index:myAppraise":
                        target = menus.find(
                            (menu) =>
                            menu.type == "1" && menu.code.includes("vinda:appraise:myAppraise")
                        );
                        if (target) {
                            url = target.url.trim();
                        }
                        break;
                    case "index:teamAppraise":
                        target = menus.find(
                            (menu) =>
                            menu.type == "1" && (menu.code.includes("vinda:appraise:teamAppraise") || menu.code.includes("vinda:rank"))
                        );
                        if (target) {
                            url = target.url.trim();
                        }
                        break;
                }
                if (url != router.currentRoute.fullPath) {
                    if(flag){
                    dispatch('handleSetAsideOpen', url)
                        router.push({
                            path: url,
                        });
                    }
                    // else{  //切换左侧菜单选中经常失效 干脆不改了
                    //     displaych('handleSetAsideOpen','/vinda/rankList')
                    // }
                    
                    // setTimeout(() => {            //注释此处可以让进入页面后不重新加载,暂时不知道有什么副作用
                    //     location.reload();  
                    // }, 500);
                }
            })
        }
    },
    handleClearInLogout({
        commit
    }) {
        commit('handleSetCurrentRole', {});
        commit('handleSetUserInfo', {})
    },
    handleRedirect({ commit }, url) {
        commit('SET_REDIRECTURL', url);
    },
    handleOALanguage({ commit }, lan) {
        commit('setLanguage', lan)
    },
    handleClearRole({ commit }) {
        Service.fetch({
            url: 'clearRole',
        }).then(res => {
            commit('handleSetCurrentRole', {});
        })
    }
}

export default actions;